import { render, staticRenderFns } from "./subhealth.vue?vue&type=template&id=e357d422&"
import script from "./subhealth.vue?vue&type=script&lang=js&"
export * from "./subhealth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports